import React, { useState } from "react";
import "./AuthModal.css";
import { useAuth } from "../../context/AuthContext";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

const AuthModal = ({ closeModal }) => {
  const { login } = useAuth();

  // States
  const [isLogin, setIsLogin] = useState(true); 
  const [isForgot, setIsForgot] = useState(false); // forgot password mode
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [forgotEmail, setForgotEmail] = useState(""); // email for forgot password
  const [message, setMessage] = useState("");

  // Toggle Login <-> Signup
  const switchMode = () => {
    setIsLogin(!isLogin);
    setIsForgot(false);
    setMessage("");
    setName("");
    setEmail("");
    setPassword("");
    setForgotEmail("");
  };

  // Toggle Forgot Password
  const switchForgot = () => {
    setIsForgot(!isForgot);
    setMessage("");
    setForgotEmail("");
    setEmail("");
    setPassword("");
    setName("");
  };

  // Handle Login
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("/api/userauth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      if (!data.success) return setMessage(data.message);

      login(data.token, data.data);
      closeModal();
    } catch (err) {
      setMessage("Login failed");
    }
  };

  // Handle Signup
 const handleSignup = async (e) => {
  e.preventDefault();
  try {
    const res = await fetch("/api/userauth/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fullName: name, email, password }),
    });

    const data = await res.json();
    if (!data.success) return setMessage(data.message);

    // ❌ Remove auto-login
    setMessage(data.message); // "Please verify your email before logging in."

    // Optionally switch to login mode
    setIsLogin(true);
  } catch (err) {
    setMessage("Signup failed");
  }
};


  // Handle Forgot Password
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("/api/userauth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: forgotEmail }),
      });

      const data = await res.json();
      if (!data.success) return setMessage(data.message);

      setMessage(data.message);
    } catch (err) {
      setMessage("Failed to send reset link");
    }
  };
  // Handle Google Login
 // Handle Google Login (updated)
const handleGoogleSuccess = async (credentialResponse) => {
  try {
    const decoded = jwtDecode(credentialResponse.credential);

    const res = await fetch("/api/userauth/google-login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        fullName: decoded.name,
        email: decoded.email,
        googleId: decoded.sub,
        profilePic: decoded.picture,
      }),
    });

    const data = await res.json();
    if (!data.success) return setMessage(data.message);

login(data.token, data.user);
    closeModal();
  } catch (err) {
    console.error("Google login failed:", err);
    setMessage("Google login failed");
  }
};


  return (
    <div className="auth-overlay">
      <div className="auth-modal">

        <button className="modal-close-btn-auth" onClick={closeModal}>
          ×
        </button>

        <h2>
          {isForgot ? "Forgot Password" : isLogin ? "Login" : "Sign Up"}
        </h2>

        {message && <p className="auth-message">{message}</p>}

        {!isForgot ? (
          <form onSubmit={isLogin ? handleLogin : handleSignup}>
            {!isLogin && (
              <input
                type="text"
                placeholder="Full Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required={!isLogin}
              />
            )}

            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button type="submit" className="auth-submit-btn">
              {isLogin ? "Login" : "Create Account"}
            </button>
          </form>
        ) : (
          <form onSubmit={handleForgotPassword}>
            <input
              type="email"
              placeholder="Enter your email"
              value={forgotEmail}
              onChange={(e) => setForgotEmail(e.target.value)}
              required
            />
            <button type="submit" className="auth-submit-btn">
              Send Reset Link
            </button>
          </form>
        )}
{/* 🌐 Google Login Button */}
{!isForgot && (
  <>
    <div style={{ textAlign: "center", margin: "15px 0", color: "#666" }}>
      — or continue with —
    </div>
    <div style={{ display: "flex", justifyContent: "center" }}>
      <GoogleLogin
        onSuccess={handleGoogleSuccess}
        onError={() => setMessage("Google Sign-In Failed")}
      />
    </div>
  </>
)}


        {!isForgot ? (
          <p className="switch-text">
            {isLogin ? "New user?" : "Already have an account?"}
            <span onClick={switchMode} className="switch-link">
              {isLogin ? " Create an account" : " Login now"}
            </span>
            {isLogin && (
              <>
                {" | "}
                <span onClick={switchForgot} className="switch-link">
                  Forgot Password?
                </span>
              </>
            )}
          </p>
        ) : (
          <p className="switch-text">
            Remembered your password?{" "}
            <span onClick={switchForgot} className="switch-link">
              Back to Login
            </span>
          </p>
        )}
      </div>
    </div>
  );
};

export default AuthModal;
